export default function ResumeHeader({ data, template, accent }) {
  const align = template.nameAlign;
  const nameStyle = template.nameStyle;

  let nameStyles = {
    fontFamily: template.nameFont,
    color: '#111',
    margin: 0,
  };

  if (nameStyle === 'uppercase-tracked') {
    nameStyles = {
      ...nameStyles,
      fontSize: '28pt',
      letterSpacing: '0.28em',
      textTransform: 'uppercase',
      fontWeight: 500,
    };
  } else if (nameStyle === 'sans-uppercase-tracked') {
    nameStyles = {
      ...nameStyles,
      fontSize: '24pt',
      letterSpacing: '0.32em',
      textTransform: 'uppercase',
      fontWeight: 500,
    };
  } else if (nameStyle === 'sans-bold') {
    nameStyles = {
      ...nameStyles,
      fontSize: '26pt',
      fontWeight: 700,
      letterSpacing: '-0.01em',
    };
  } else if (nameStyle === 'sans-bold-uppercase') {
    nameStyles = {
      ...nameStyles,
      fontSize: '26pt',
      fontWeight: 800,
      letterSpacing: '0.04em',
      textTransform: 'uppercase',
    };
  } else if (nameStyle === 'serif-display') {
    nameStyles = {
      ...nameStyles,
      fontSize: '30pt',
      fontWeight: 500,
      letterSpacing: '0.01em',
    };
  }

  const contactItems = [
    data.contact.location,
    data.contact.phone,
    data.contact.email,
    data.contact.linkedin,
    data.contact.website,
  ].filter(Boolean);

  const contactStyle = {
    fontFamily: template.bodyFont,
    fontSize: '9.5pt',
    color: '#3a3a3a',
    letterSpacing: '0.02em',
  };

  if (align === 'center') {
    return (
      <div style={{ textAlign: 'center', marginTop: template.decorativeMark === 'corner-arc' ? '0.2in' : 0 }}>
        <h1 style={nameStyles}>{data.name || 'Your Name'}</h1>
        <div style={{ ...contactStyle, marginTop: '0.12in' }}>
          {contactItems.join('  |  ')}
        </div>
      </div>
    );
  }

  if (align === 'left') {
    return (
      <div style={{ textAlign: 'left', marginTop: template.decorativeMark === 'corner-arc' ? '0.2in' : 0 }}>
        <h1 style={nameStyles}>{data.name || 'Your Name'}</h1>
        {template.decorativeMark === 'name-rule' && (
          <div style={{ width: '1.4in', height: '1.5px', background: accent, marginTop: '0.06in' }} />
        )}
        {template.decorativeMark === 'name-rule-orange' && (
          <div style={{ width: '1.4in', height: '2px', background: template.accent2 || accent, marginTop: '0.08in' }} />
        )}
        <div style={{ ...contactStyle, marginTop: '0.12in' }}>
          {contactItems.join('  |  ')}
        </div>
      </div>
    );
  }

  return (
    <div style={{
      display: 'flex',
      alignItems: 'baseline',
      justifyContent: 'space-between',
      gap: '0.3in',
      marginTop: template.decorativeMark === 'corner-arc' ? '0.2in' : 0,
    }}>
      <h1 style={nameStyles}>{data.name || 'Your Name'}</h1>
      <div style={{ ...contactStyle, textAlign: 'right', maxWidth: '3.5in', lineHeight: 1.5 }}>
        {contactItems.map((item, i) => (
          <div key={i}>{item}</div>
        ))}
      </div>
    </div>
  );
}
